import { doc, onSnapshot } from 'firebase/firestore';
import { Clock, Gamepad2, Trophy, Users, Zap } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../config/firebaseConfig';

const GameStatusIndicator = () => {
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState(localStorage.getItem('roomId') || '');
  const [roomData, setRoomData] = useState(null);

  // Listen to room document for game state updates
  useEffect(() => {
    if (!roomId) {
      setRoomData(null);
      return;
    }

    const roomRef = doc(db, 'rooms', roomId);
    const unsubscribe = onSnapshot(
      roomRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setRoomData(snapshot.data());
        } else {
          setRoomData(null);
        }
      },
      (error) => {
        console.error('Error listening to room:', error);
      }
    );

    return () => unsubscribe();
  }, [roomId]);

  if (!roomId || !roomData) {
    return null;
  }

  const gameStage = roomData?.gameState?.stage;
  const isAstraPos = roomData?.roomType === 'ASTRAPOS';

  // Only show for AstraPOS games
  if (!isAstraPos) {
    return null;
  }

  // Determine stage color and icon
  const stageConfig = {
    WAITING: {
      label: 'Waiting',
      color: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
      icon: Users,
      bgHover: 'hover:bg-blue-500/20',
    },
    STAKING: {
      label: 'Staking',
      color: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
      icon: Zap,
      bgHover: 'hover:bg-yellow-500/20',
    },
    WINNER_DISPLAY: {
      label: 'Assigning',
      color: 'bg-purple-500/10 text-purple-400 border-purple-500/20',
      icon: Trophy,
      bgHover: 'hover:bg-purple-500/20',
    },
    PLAYING: {
      label: 'Playing',
      color: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
      icon: Gamepad2,
      bgHover: 'hover:bg-emerald-500/20',
    },
    LEADERBOARD: {
      label: 'Leaderboard',
      color: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
      icon: Trophy,
      bgHover: 'hover:bg-orange-500/20',
    },
  };

  const config = stageConfig[gameStage] || stageConfig.WAITING;
  const IconComponent = config.icon;

  return (
    <button
      onClick={() => navigate('/game')}
      className={`fixed top-6 right-6 z-50 inline-flex items-center gap-2 px-4 py-2 rounded-full border transition-all duration-200 cursor-pointer backdrop-blur-sm ${config.color} ${config.bgHover}`}
      title="Click to go to game"
    >
      <IconComponent size={16} className="animate-pulse" />
      <span className="text-sm font-semibold">{config.label}</span>
    </button>
  );
};

export default GameStatusIndicator;
